import Typography from '@components/common/typography';
import { Icon } from '@components/icons';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { useXepptCardModals } from '@hooks/modals/useXepptCardModals';
import useModalContext from '@hooks/context/useModalContext';
import { ECardStatus } from '@xeppt/xeppt-sdk/types';

const ManageCardModal = () => {
    const { modalData } = useModalContext();
    const { t } = useTranslation('modals', {
        keyPrefix: 'manage_card'
    });
    const {
        handleOpenLimitsModal,
        handleOpenCancelCardModal,
        handleOpenUpdatePinModal,
        handleOpenCardAgreementModal,
        handleOpenReplaceCardModal
    } = useXepptCardModals({ card: modalData });

    return (
        <div className={styles.wrapper}>
            <Typography variant="h4" weight="semibold">
                {t('title')}
            </Typography>
            <div className={styles.content}>
                {modalData?.status === ECardStatus.ACTIVE && (
                    <button className={styles.link} onClick={handleOpenUpdatePinModal}>
                        <div className={styles.text_wrapper}>
                            <span>
                                <Icon name="pin" />
                            </span>
                            <Typography variant="body1">Set PIN</Typography>
                        </div>
                        <Icon name="nav_right" />
                    </button>
                )}
                {modalData?.status === ECardStatus.ACTIVE && (
                    <button className={styles.link} onClick={handleOpenCancelCardModal}>
                        <div className={styles.text_wrapper}>
                            <span className={styles.red}>
                                <Icon name="close_outlined" />
                            </span>
                            <Typography className={styles.red} variant="body1">
                                {t('cancel_card')}
                            </Typography>
                        </div>
                        <Icon name="nav_right" />
                    </button>
                )}
                {modalData?.status === ECardStatus.ACTIVE && (
                    <button className={styles.link} onClick={handleOpenReplaceCardModal}>
                        <div className={styles.text_wrapper}>
                            <span className={styles.red}>
                                <Icon name="replace_card" />
                            </span>
                            <Typography className={styles.red} variant="body1">
                                {t('replace_card')}
                            </Typography>
                        </div>
                        <Icon name="nav_right" />
                    </button>
                )}
                <div className={styles.divider} />
                <button className={styles.link} onClick={handleOpenLimitsModal}>
                    <div className={styles.text_wrapper}>
                        <span>
                            <Icon name="limit" />
                        </span>
                        <Typography variant="body1">{t('view_limits')}</Typography>
                    </div>
                    <Icon name="nav_right" />
                </button>
                <button className={styles.link} onClick={handleOpenCardAgreementModal}>
                    <div className={styles.text_wrapper}>
                        <span>
                            <Icon name="document" />
                        </span>
                        <Typography variant="body1">Agreement</Typography>
                    </div>
                    <Icon name="nav_right" />
                </button>
            </div>
        </div>
    );
};

export default ManageCardModal;
